module.exports = __webpack_public_path__ + "img/iconMaterialTest.25f6b85e.svg";